export var AuditDefParamType;
(function (AuditDefParamType) {
    AuditDefParamType[AuditDefParamType["Keywords"] = 0] = "Keywords";
    AuditDefParamType[AuditDefParamType["Percent"] = 2] = "Percent";
    AuditDefParamType[AuditDefParamType["Currency"] = 3] = "Currency";
    AuditDefParamType[AuditDefParamType["CurrencyType"] = 4] = "CurrencyType";
    AuditDefParamType[AuditDefParamType["DistanceUnits"] = 5] = "DistanceUnits";
})(AuditDefParamType || (AuditDefParamType = {}));
export var AuditDefType;
(function (AuditDefType) {
    AuditDefType[AuditDefType["BriberyCorruption"] = 0] = "BriberyCorruption";
    AuditDefType[AuditDefType["ExcessiveSpend"] = 1] = "ExcessiveSpend";
    AuditDefType[AuditDefType["InvalidExpenseTypes"] = 2] = "InvalidExpenseTypes";
    AuditDefType[AuditDefType["InvalidReceipts"] = 3] = "InvalidReceipts";
    AuditDefType[AuditDefType["SuspiciousPatterns"] = 4] = "SuspiciousPatterns";
    AuditDefType[AuditDefType["InvalidMerchantCode"] = 5] = "InvalidMerchantCode";
})(AuditDefType || (AuditDefType = {}));
export var ExceptionDetailType;
(function (ExceptionDetailType) {
    ExceptionDetailType[ExceptionDetailType["EMPLOYEE"] = 0] = "EMPLOYEE";
    ExceptionDetailType[ExceptionDetailType["EXPENSE_CATEGORY"] = 2] = "EXPENSE_CATEGORY";
    ExceptionDetailType[ExceptionDetailType["DEPARTMENT"] = 5] = "DEPARTMENT";
})(ExceptionDetailType || (ExceptionDetailType = {}));
